import { Component, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { Funcionalidad } from '../../_models/funcionalidad';
import { NavService } from '../../_services/_nav.service';
import { Router } from '@angular/router';
import { AutenticacionService } from '../../_services/autenticacion.service';
import { PalabraClave } from '../../_models/palabra-clave';
import { PalabraClaveService } from '../../_services/palabra-clave.service';
import { PalabraClaveActividadEconomica } from '../../_models/palabra-clave-actividad-economica';
import { PalabraClaveActividadEconomicaService } from '../../_services/palabra-clave-actividad-economica.service';

@Component( {
  selector: 'app-palabra-clave-listado',
  templateUrl: 'palabra-clave-listado.component.html'
} )

export class PalabraClaveListadoComponent implements OnInit {

  palClaves: PalabraClave[] = [];
  carTabla = true;
  columnas: any[];
  colActividades: any[];
  busqueda: string;
  @ViewChild('dt', { static: true }) tabla: Table;
  menu: Funcionalidad = new Funcionalidad();
  mosDetalle = false;
  palClaveSeleccionada: PalabraClave;
  palClaveActividades: PalabraClaveActividadEconomica[] = [];
  carActividades = false;

  constructor( private palClaveServicio: PalabraClaveService,
               private navServicio: NavService,
               private router: Router,
               private palClaveActividadServicio: PalabraClaveActividadEconomicaService,
               private autServicio: AutenticacionService ) {
  }

  ngOnInit(): void {
    const mn = this.autServicio.obtenerFuncionalidades().find( x => x.ruta === 'apl/palabra-clave' );
    if ( mn ) {
      this.menu = mn;
    }

    this.colActividades = [
      { field: 'nombreActividadEconomica', header: this.navServicio.buscarMensaje( 'PALABRACLAVE.LBL_ACTIVIDADECONOMICA' ), sort: true }
    ];

    this.columnas = [
      { field: 'codigo', header: this.navServicio.buscarMensaje( 'PALABRACLAVE.LBL_CODIGO' ), sort: true },
      { field: 'nombre', header: this.navServicio.buscarMensaje( 'PALABRACLAVE.LBL_NOMBRE' ), sort: true },
      { field: 'numeroActividadesEconomicas', header: this.navServicio.buscarMensaje( 'PALABRACLAVE.LBL_NUMEROACTIVIDADES' ), sort: true },
      { field: 'indicadorHabilitado', header: this.navServicio.buscarMensaje( 'LBL_HABILITADO' ), sort: true },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];
    this.busqueda = this.navServicio.getSearch( 'palabra-clave.component' );

    this.palClaveServicio.listado().subscribe( palClaves => {
      this.palClaves = palClaves;
      this.carTabla = false;
      this.tabla.filterGlobal( this.busqueda, 'contains' );
    } );
  }

  crear() {
    this.router.navigate( [ 'apl/palabra-clave/agregar' ] );
  }

  ver( palClave: PalabraClave ) {
    this.router.navigate( [ 'apl/palabra-clave/detalle/' + palClave.idPalabraClave ] );
  }

  editar( palClave: PalabraClave ) {
    this.router.navigate( [ 'apl/palabra-clave/actualizar/' + palClave.idPalabraClave ] )
  }

  setBusqueda() {
    this.navServicio.setSearch( 'palabra-clave.component', this.busqueda );
  }

  cerrar() {
    this.mosDetalle = false;
  }

  verActividades( palClave: PalabraClave ) {
    this.carTabla = true;
    this.palClaveSeleccionada = palClave;
    this.palClaveActividades = [];
    this.carActividades = true;
    this.palClaveActividadServicio.listadoPorPalabraClave( palClave.idPalabraClave ).subscribe( actividades => {
      this.palClaveActividades = actividades;
      this.carActividades = false;
      this.carTabla = false;
      this.mosDetalle = true;
    } );
  }
}
